/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxcRegistrationV1ProfileQueryServiceProfileListProfileListRequest, IxcRegistrationV1ProfileQueryServiceProfileListResponse } from '@interxfi/types';

export const IXC_REGISTRATION_V1_PROFILE_QUERY_SERVICE_PROFILE_LIST_AUDIENCE = ['clearing', 'program'];

export async function ixcRegistrationV1ProfileQueryServiceProfileList(baseUrl: string | undefined, request?: IxcRegistrationV1ProfileQueryServiceProfileListProfileListRequest, requestInit?: RequestInit): Promise<IxcRegistrationV1ProfileQueryServiceProfileListResponse | undefined> { return makeRequest<IxcRegistrationV1ProfileQueryServiceProfileListResponse, IxcRegistrationV1ProfileQueryServiceProfileListProfileListRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixc/registration/v1/profile/q', request, requestInit)); }

